import { unprefix } from '@lglp/utils';
import { compose, isEmpty, prop, toUpper } from 'ramda';

import { clear } from '../../../helpers/compact';
import { toText } from './text';

export type Thumbnail = {
  src?: string;
  width?: number;
  height?: number;
};

export type Image = {
  src?: string;
  alt?: string;
  copyright?: string;
  thumbnail?: Thumbnail;
  width?: number;
  height?: number;
  title?: string;
  desc?: string;
  caption?: string;
};

const toThumb = ({
  url,
  dimensions: { width, height } = {},
  ...rest
}: {
  url: string;
  dimensions: Record<string, number>;
}): Thumbnail =>
  clear({
    ...rest,
    src: url,
    width: width,
    height: height,
  });

const thumbs: (val: Record<string, any>) => Record<string, Thumbnail> = (
  val
) => {
  const thumbs = (unprefix('thumb', val) as Record<string, any>) || {};

  return Object.entries(thumbs).reduce((acc, [key, thumb]) => {
    const normalizedThumb = toThumb(thumb);

    if (isEmpty(thumb)) {
      return acc;
    }
    const normalizedThumbKey = key.replace(
      /[-_][a-z]/g,
      (val: string): string => toUpper(val[1])
    );
    return { ...acc, [normalizedThumbKey]: normalizedThumb };
  }, {});
};

export const toImage = ({
  url,
  alt,
  dimensions,
  copyright,
  ...rest
}: any = {}): Image => {
  if (url) {
    return clear({
      src: url,
      alt: toText(alt),
      copyright: toText(copyright),
      thumbnail: thumbs(rest),
      width: dimensions?.width,
      height: dimensions?.height,
    });
  }
};

export const toImageFromProp = compose(toImage, prop);
